<template>
  <el-dialog
    title="问诊单名称"
    :visible.sync="dialog"
    width="80%"
    style="text-align:left;"
    :close-on-click-modal="false"
    :before-close="beforeClose"
    append-to-body
    class="big"
  >
    <div class="inquiry-dialog">
      <div style="margin-bottom: 10px">
        <span style="font-weight: 700; margin-right: 10px">患者是否填写</span>
        <span>{{ is_inquiry |inquiryText }}</span>
      </div>
      <div>
        <span style="font-weight: 700; margin-right: 10px">问诊单作用说明</span>
        <span>{{ desc }}</span>
      </div>
      <el-divider></el-divider>
      <div>
        <div
          v-for="(item, index) in qlist"
          :key="index"
        >
          <!-- 单选 -->
          <div
            v-if="item.item_type == 1"
            class="listitem"
          >
            <div style="margin-bottom: 10px">
              <span>{{ index + 1 }}、</span>
              <span>{{ item.title }}：</span>
              <span class="gray">
                <span>（单选）</span>
                <span v-if="item.answer_obj == 1">患者填写</span>
                <span v-if="item.answer_obj == 2">医生填写</span>
              </span>
              <span
                v-if="item.is_write == 0"
                style="margin-left: 100px"
                class="gray"
              >（非必填）</span>
            </div>
            <div>
              <el-radio-group v-model="item.content">
                <el-radio
                  :label="va"
                  v-for="(va, i) in item.check_content"
                  :key="i"
                  style="word-break: break-all"
                ></el-radio>
              </el-radio-group>
            </div>
          </div>
          <!-- 多选 -->
          <div
            v-if="item.item_type == 2"
            class="listitem"
          >
            <div style="margin-bottom: 10px">
              <span>{{ index + 1 }}、</span>
              <span>{{ item.title }}：</span>
              <span class="gray">
                <span>（多选）</span>
                <span v-if="item.answer_obj == 1">患者填写</span>
                <span v-if="item.answer_obj == 2">医生填写</span>
              </span>
              <span
                v-if="item.is_write == 0"
                style="margin-left: 100px"
                class="gray"
              >（非必填）</span>
            </div>
            <div>
              <el-checkbox-group v-model="item.content">
                <el-checkbox
                  :label="va"
                  v-for="(va, i) in item.check_content"
                  :key="i"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <!-- 文本 -->
          <div
            v-if="item.item_type == 3"
            class="listitem"
          >
            <div style="margin-bottom: 10px">
              <span>{{ index + 1 }}、</span>
              <span>{{ item.title }}：</span>
              <span class="gray">
                <span v-if="item.answer_obj == 1">患者填写</span>
                <span v-if="item.answer_obj == 2">医生填写</span>
              </span>
              <span
                v-if="item.is_write == 0"
                class="gray"
              >（非必填）</span>
            </div>
            <div>
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                :placeholder="item.desc"
                v-model="item.content"
                style="width: 800px"
                maxlength="300"
                show-word-limit
              >
              </el-input>
            </div>
          </div>
          <!-- 填空题 -->
          <div
            v-if="item.item_type == 4"
            class="listitem"
          >
            <div>
              <span>{{ index + 1 }}、</span>
              <gap
                :html="item.html"
                :content="item.content"
              ></gap>
              <span
                class="gray"
                style="margin-left: 80px"
              >
                <span v-if="item.answer_obj == 1">患者填写</span>
                <span v-if="item.answer_obj == 2">医生填写</span>
              </span>
              <span
                v-if="item.is_write == 0"
                class="gray"
              >（非必填）</span>
            </div>
          </div>
          <!-- 上传图片 -->
          <div
            v-if="item.item_type == 5"
            class="listitem"
          >
            <div style="margin-bottom: 10px">
              <span>{{ index + 1 }}、</span>
              <span>{{ item.title }}</span>
              <span class="gray">（最多上传{{ item.img_num }}张图片）</span>
              <span
                class="gray"
                style="margin-left: 100px"
              >
                <span v-if="item.answer_obj == 1">患者填写</span>
                <span v-if="item.answer_obj == 2">医生填写</span>
              </span>
              <span
                v-if="item.is_write == 0"
                class="gray"
              >（非必填）</span>
            </div>
            <div class="flex">
              <div
                class="avatar"
                v-for="(img, g) in item.content"
                :key="g"
              >
                <img
                  :src="img"
                  style="width: 100%; height: 100%"
                />
                <div
                  class="iconbox"
                  @click="delImg(index, g)"
                >
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <div class="imgbox">
                <el-upload
                  name="image"
                  accept=".png,.jpeg,.jpg"
                  :action="uploadUrl"
                  :data="uploadExtraData"
                  :headers="uploadHeaders"
                  :show-file-list="false"
                  :on-success="
                      (res, file, fileList) => {
                        return handleAvatarSuccess(res, file, fileList, index);
                      }
                    "
                  :before-upload="
                      (file) => {
                        return beforeAvatarUpload(file, index, item.img_num);
                      }
                    "
                >
                  <div>
                    <i class="el-icon-plus uploader-icon"></i>
                  </div>
                </el-upload>
              </div>
            </div>
            <div
              style="margin-top: 10px"
              v-if="!item.is_desc"
            >
              <div>描述：</div>
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                v-model="item.desc"
                maxlength="300"
                style="width: 800px"
                show-word-limit
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="close"
        plain
      >关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import Vue from 'vue';
import constant from '../../../../service/common/constant';
import _ from 'lodash';
export default {
  components: {
    gap: {
      props: {
        html: String,
        content: Object
      },
      render(h) {
        const com = Vue.extend({
          template: this.html,
          props: {
            content: Object
          },
          methods: {
            change(value) {}
          }
        });
        return h(com, {
          props: {
            content: this.content
          }
        });
      }
    }
  },
  props: {
    consult_inquiry_id: {
      type: [String, Number],
      required: true,
      default: ''
    }
  },
  data() {
    return {
      dialog: true,
      is_inquiry: 1,
      qlist: [],
      uploadExtraData: {
        img_type: 1,
        suffix: '.jpg'
      },
      business_id: '',
      desc: ''
    };
  },
  filters: {
    inquiryText(val) {
      switch (val) {
        case 0:
          return '未填写';
        case 1:
          return '已填写';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  created() {
    this.getDetail();
  },
  methods: {
    //获取详情
    getDetail() {
      let consult_inquiry_id = this.consult_inquiry_id;
      this.axios
        .post('platform/Inquirysheet/getConsultInquiryContentInfo', {
          consult_inquiry_id
        })
        .then((res) => {
          if (res.code == 0) {
            this.business_id = res.data.info.business_id;
            this.desc = res.data.info.desc;
            this.qlist = res.data.info.content.map((item) => {
              //单选
              if (item.item_type == 1) {
                item.check_content = item.check_content.split('^');
              }
              //多选
              if (item.item_type == 2) {
                item.content = !item.content
                  ? ''.split('^')
                  : item.content.split('^');
                item.check_content = item.check_content.split('^');
              }
              //填空
              if (item.item_type == 4) {
                let content_str = [];
                if (item.content) {
                  content_str = _.cloneDeep(item.content).split('^');
                }
                item.html = '';
                item.content = {};
                let index = 0;
                let htmlvalue = item.title.replace(
                  /\{\$(.+?)\}/g,
                  (match, a) => {
                    if (item.content) {
                      this.$set(
                        item.content,
                        'value' + index,
                        content_str[index]
                      );
                    } else {
                      this.$set(item.content, 'value' + index, '');
                    }
                    index++;
                    return `<el-input style='width:200px' v-model='content.value${
                      index - 1
                    }' placeholder='${match}' class='my-input' maxlength="20"  />`;
                  }
                );
                item.html = `<span>${htmlvalue.replace(
                  /\{|\}|\$/g,
                  ''
                )}</span>`;
              }
              //图片
              if (item.item_type == 5) {
                item.content = item.content ? item.content.split('^') : [];
              }
              return item;
            });
          }
        });
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList, index) {
      if (res.code === 0) {
        this.qlist[index].content.push(res.data.path);
      }
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeAvatarUpload(file, index, img_num) {
      let length = this.qlist[index].content.length;
      if (length >= img_num && img_num) {
        this.$message.error(`最多上传${img_num}张图片`);
        return false;
      }
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadExtraData.img_type = 4;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const width = 750;
          const height = (750 / image.width) * image.height;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    //删除图片
    delImg(index, g) {
      this.qlist[index].content.splice(g, 1);
    },
    //提交  1单选，2多选，3文本，4填空题，5图片
    submit() {
      let qlist = JSON.parse(JSON.stringify(this.qlist));
      let content = qlist.map((item) => {
        //单选
        if (item.item_type == 1) {
          item.check_content = item.check_content.join('^');
        }
        //多选
        if (item.item_type == 2) {
          item.content = item.content.join('^');
          item.check_content = item.check_content.join('^');
        }
        //填空
        if (item.item_type == 4) {
          item = _.omit(item, 'html');
          let content_arr = [];
          for (let key in item.content) {
            content_arr.push(item.content[key]);
          }
          item.content = content_arr.join('^');
        }
        //图片
        if (item.item_type == 5) {
          item.content = item.content.join('^');
        }
        return item;
      });
      let data = {
        business_id: this.business_id,
        content: content,
        // consult_inquiry_id: this.$route.query.consult_inquiry_id
        consult_inquiry_id: 970
      };
      this.axios
        .post('platform/Inquirysheet/updateConsultInquiryContent', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.back();
          }
        });
    },
    close() {
      this.$emit('close');
    },
    beforeClose() {
      this.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.inquiry-dialog {
  padding: 20px;
}
.gray {
  color: #cacaca;
}
.listitem {
  margin-bottom: 20px;
}
.imgbox {
  width: 120px;
  height: 120px;
  background-color: #fff;
  border: solid 1px #d6d6d6;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .uploader-icon {
    font-size: 30px;
    color: #d6d6d6;
  }
}
.avatar {
  width: 120px;
  height: 120px;
  margin-right: 10px;
  position: relative;
  .iconbox {
    width: 120px;
    height: 120px;
    font-size: 24px;
    color: #fff;
    background: rgba(172, 172, 172, 0.575);
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 120px;
    text-align: center;
    cursor: pointer;
    display: none;
  }
  &:hover {
    .iconbox {
      display: block;
    }
  }
}
</style>
<style lang="scss">
.inquiry .el-radio__label {
  width: 100% !important;
  text-overflow: ellipsis;
  white-space: normal;
}
.inquiry .el-checkbox__label {
  width: 100% !important;
  text-overflow: ellipsis;
  white-space: normal;
}
</style>
